export { default as StrategyMapContent } from './StrategyMapContent';
